import {
  GET_SINGLE_SURVEY,
  GET_USER_SURVEYS,
  SUBMIT_SURVEY_RESPONSE,
} from "../../constants/api_constants";
import { handleApi } from "../utils";

export const getUserSurveys = async () => {
  return handleApi("get", GET_USER_SURVEYS);
};

export const getSingleSurvey = async (id) => {
  return handleApi("get", `${GET_SINGLE_SURVEY}/${id}`);
};

export const submitSurveyResponse = async (id, values) => {
  return handleApi("post", `${SUBMIT_SURVEY_RESPONSE}/${id}/respond`, values);
};
